import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authService = { login: (d) => api.post('/auth/login', d), me: () => api.get('/auth/me'), register: (d) => api.post('/auth/register', d) };
export const ticketService = { getAll: (p) => api.get('/tickets', { params: p }), getById: (id) => api.get(`/tickets/${id}`), create: (d) => api.post('/tickets', d), update: (id, d) => api.patch(`/tickets/${id}`, d), addComment: (id, d) => api.post(`/tickets/${id}/comments`, d), getStats: () => api.get('/tickets/stats'), getAssignees: (appId) => api.get('/tickets/assignees', { params: { appId } }) };
export const clientService = { getAll: () => api.get('/clients'), getById: (id) => api.get(`/clients/${id}`), create: (d) => api.post('/clients', d), update: (id, d) => api.patch(`/clients/${id}`, d) };
export const adminService = { listClients: () => api.get('/admin/clients'), createClient: (d) => api.post('/admin/clients', d), updateClient: (id, d) => api.patch(`/admin/clients/${id}`, d), getClientOverview: (id) => api.get(`/admin/clients/${id}/overview`), regenerateWidgetKey: (id) => api.post(`/admin/clients/${id}/regenerate-key`) };
export const appService = { getAll: () => api.get('/apps'), create: (d) => api.post('/apps', d), update: (id, d) => api.patch(`/apps/${id}`, d) };
export const deploymentService = { getAll: (p) => api.get('/deployments', { params: p }), getById: (id) => api.get(`/deployments/${id}`), create: (d) => api.post('/deployments', d), update: (id, d) => api.patch(`/deployments/${id}`, d), regenerateKey: (id) => api.post(`/deployments/${id}/regenerate-key`), setMaintenance: (id, d) => api.post(`/deployments/${id}/maintenance`, d) };
export const observabilityService = { getOverview: () => api.get('/observability/overview'), getDeploymentMetrics: (id, range) => api.get(`/observability/deployment/${id}/metrics`, { params: { range } }), getIncidents: (p) => api.get('/observability/incidents', { params: p }), updateIncident: (id, d) => api.patch(`/observability/incidents/${id}`, d), getUptimeReport: () => api.get('/observability/uptime'), getHeartbeatHistory: (id, limit) => api.get(`/heartbeat/${id}/history`, { params: { limit } }) };
export const notificationService = { getRules: () => api.get('/notifications/rules'), createRule: (d) => api.post('/notifications/rules', d), updateRule: (id, d) => api.patch(`/notifications/rules/${id}`, d), deleteRule: (id) => api.delete(`/notifications/rules/${id}`), getLogs: (p) => api.get('/notifications/logs', { params: p }) };
export const dashboardService = { getSummary: () => api.get('/dashboard/summary') };
export const slaService = {
  getPolicy: () => api.get('/sla/policy'),
  updatePolicy: (data) => api.put('/sla/policy', data),
  preview: (data) => api.post('/sla/preview', data),
  analytics: (params) => api.get('/sla/analytics', { params }),
};

export const trialRequestService = {
  getAll: (p) => api.get('/trial-requests', { params: p }),
  getById: (id) => api.get(`/trial-requests/${id}`),
  update: (id, d) => api.patch(`/trial-requests/${id}`, d),
  addNote: (id, text) => api.post(`/trial-requests/${id}/notes`, { text }),
  pdf: (id) => api.get(`/trial-requests/${id}/pdf`, { responseType: 'blob' }),
};

export const demoRequestService = {
  getAll: (p) => api.get('/demo-requests', { params: p }),
  getById: (id) => api.get(`/demo-requests/${id}`),
  update: (id, d) => api.patch(`/demo-requests/${id}`, d),
  addNote: (id, text) => api.post(`/demo-requests/${id}/notes`, { text }),
};

export default api;
